import { Injectable } from '@angular/core';
import { LocalContentService } from '../local-content/local-content.service'

@Injectable({
  providedIn: 'root'
})
export class VocabularyService {

  public useLangs=false;

  constructor(public localContentService:LocalContentService) {
    localContentService.getStaticContent().subscribe((data)=>{
      
      if (data&&data.meta) {
        Object.assign(this,data.meta.vocabulary);
        this.useLangs=!!(Object.keys(data.meta.languages).length>1);
      }
    }
  )
  }


}
